import { isURL } from './validate'
import device_status_info from '@/views/WorkshopBoard/View.vue'
import defect_distribution from '@/views/ControlMonitor/ProductionInfo.vue'

/**
 * 生成嵌套路由（子路由）
 * @param {*} data
 */
function generateChildRouters(data) {
	const routers = []

	for (const item of data) {
		let component = ''
		//过滤掉非私有云系统的菜单。
		//if (item.name.indexOf('gmqm') == -1) continue

		if (item.component.indexOf('layouts') >= 0) {
			component = 'components/' + item.component
		} else {
			component = 'views/' + item.component
		}

		// eslint-disable-next-line
		let URL = (item.meta.url || '').replace(/{{([^}}]+)?}}/g, (s1, s2) => eval(s2)) // URL支持{{ window.xxx }}占位符变量
		if (isURL(URL)) {
			item.meta.url = URL
		}

		//online菜单路由加载逻辑
		// let componentPath
		// if (item.component == 'modules/online/cgform/OnlCgformHeadList') {
		// 	componentPath = onlineCommons.OnlCgformHeadList
		// } else if (item.component == 'modules/online/cgform/OnlCgformCopyList') {
		// 	componentPath = onlineCommons.OnlCgformCopyList
		// } else if (item.component == 'modules/online/cgform/auto/OnlCgformAutoList') {
		// 	componentPath = onlineCommons.OnlCgformAutoList
		// } else if (item.component == 'modules/online/cgform/auto/OnlCgformTreeList') {
		// 	componentPath = onlineCommons.OnlCgformTreeList
		// } else if (item.component == 'modules/online/cgform/auto/erp/OnlCgformErpList') {
		// 	componentPath = onlineCommons.OnlCgformErpList
		// } else if (item.component == 'modules/online/cgform/auto/innerTable/OnlCgformInnerTableList') {
		// 	componentPath = onlineCommons.OnlCgformInnerTableList
		// } else if (item.component == 'modules/online/cgreport/OnlCgreportHeadList') {
		// 	componentPath = onlineCommons.OnlCgreportHeadList
		// } else if (item.component == 'modules/online/cgreport/auto/OnlCgreportAutoList') {
		// 	componentPath = onlineCommons.OnlCgreportAutoList
		// } else {
		// 	componentPath = resolve => require(['@/' + component + '.vue'], resolve)
		// }

		const componentPath = resolve => require(['@/' + component + '.vue'], resolve)

		const menu = {
			path: item.path,
			name: item.name,
			redirect: item.redirect,
			component: componentPath,
			hidden: item.hidden,
			//component:()=> import(`@/views/${item.component}.vue`),
			meta: {
				title: item.meta.title,
				icon: item.meta.icon,
				url: item.meta.url,
				permissionList: item.meta.permissionList,
				keepAlive: item.meta.keepAlive,
				/*update_begin author:wuxianquan date:20190908 for:赋值 */
				internalOrExternal: item.meta.internalOrExternal,
				/*update_end author:wuxianquan date:20190908 for:赋值 */
			},
		}
		if (item.alwaysShow) {
			menu.alwaysShow = true
			menu.redirect = menu.path
		}
		if (item.children && item.children.length > 0) {
			menu.children = [...generateChildRouters(item.children)]
		}

		//判断是否生成路由
		if (item.route && item.route === '0') {
			//console.log(' 不生成路由 item.route：  '+item.route);
			//console.log(' 不生成路由 item.path：  '+item.path);
		} else {
			routers.push(menu)
		}
	}

	//console.log('routers', routers)

	return routers
}

/**
 * 生成首页路由
 * @param {*} data
 */
export function generateIndexRouter(data) {
	const indexRouter = [
		{
			path: '/',
			name: 'home',
			component: resolve => require(['@/views/Home'], resolve),
			meta: { title: 'GMQM私有云', icon: 'el-icon-monitor' },
			redirect: '/index',
			children: [
				{
					path: '/index',
					name: 'index',
					component: () => import('../views/Index.vue'),
					meta: {
						title: '主页',
					},
				},
				{
					path: '/workshop/view',
					name: 'WorkshopView',
					component: device_status_info,
					meta: {
						title: '机台运行状况',
					},
				},
				{
					path: '/workshop/view',
					name: 'WorkshopView',
					component: device_status_info,
					meta: {
						title: '机台运行状况',
					},
				},
				{
					path: '/defect/joborders/ColorInfor',
					name: 'ColorInforOrderStatisticalView',
					component: () => import('../views/DefectFilter/ColorInfo.vue'),
					meta: {
						title: '统计报表',
					},
				},
				{
					path: '/control/production/defect',
					name: 'production_defect',
					component: defect_distribution,
					meta: {
						title: '缺陷分布',
					},
				},
				...generateChildRouters(data),
			],
		},
		{
			path: '*',
			redirect: '/404',
			hidden: true,
		},
	]
	return indexRouter
}

export function xmlToDom(xmlString) {
	var xmlDoc = null
	try {
		/* DOMParser 对象解析 XML 文本并返回一个 XML Document 对象。
		 * 要使用 DOMParser，使用不带参数的构造函数来实例化它，然后调用其 parseFromString() 方法
		 * parseFromString(text, contentType) 参数text:要解析的 XML 标记 参数contentType文本的内容类型
		 * 可能是 "text/xml" 、"application/xml" 或 "application/xhtml+xml" 中的一个。注意，不支持 "text/html"。
		 */
		var domParser = new DOMParser()
		xmlDoc = domParser.parseFromString(xmlString, 'text/xml')
	} catch (e) {
		console.error(e)
	}

	return xmlDoc
}

/**
 *
 * @param {*} xml
 */
export function xmlToJson(xml) {
	console.log(xml.nodeType)
	// Create the return object
	var obj = {}
	if (xml.nodeType == 1) {
		// element
		// do attributes
		if (xml.attributes.length > 0) {
			obj['@attributes'] = {}
			for (var j = 0; j < xml.attributes.length; j++) {
				var attribute = xml.attributes.item(j)
				obj['@attributes'][attribute.nodeName] = attribute.nodeValue
			}
		}
	} else if (xml.nodeType == 3) {
		// text
		obj = xml.nodeValue
	}
	// do children
	if (xml.hasChildNodes()) {
		for (var i = 0; i < xml.childNodes.length; i++) {
			var item = xml.childNodes.item(i)
			var nodeName = item.nodeName
			if (typeof obj[nodeName] == 'undefined') {
				obj[nodeName] = xmlToJson(item)
			} else {
				if (typeof obj[nodeName].length == 'undefined') {
					var old = obj[nodeName]
					obj[nodeName] = []
					obj[nodeName].push(old)
				}
				obj[nodeName].push(xmlToJson(item))
			}
		}
	}
	return obj
}
